import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component, lazy, Suspense } from 'react';
/**
 * The note of the detail panel, with its editor in a chunk of its own (ADR-0022): Tiptap only
 * downloads when a panel opens, so the initial bundle stays within its budget (docs/12 §4). While
 * it loads, the note is shown as the text it holds; if the chunk cannot be loaded (offline, a
 * failed deploy), the note is still editable as plain Markdown.
 */
const NoteEditor = lazy(async () => {
    const module = await import('./NoteEditor.js');
    return { default: module.NoteEditor };
});
/** The note as plain Markdown: the fallback while the editor loads and if it cannot load. */
function PlainNote({ value, onSave, labels, disabled }) {
    return (_jsxs("div", { className: "note-editor note-editor--plain", children: [_jsx("label", { className: "note-editor__label", htmlFor: "note-plain", children: labels.label }), _jsx("textarea", { id: "note-plain", className: "note-editor__textarea", rows: 6, disabled: disabled, defaultValue: value ?? '', placeholder: labels.placeholder, onBlur: (event) => {
                    const next = event.target.value.trim();
                    if (next === (value ?? '').trim())
                        return;
                    onSave(next === '' ? null : next);
                } }, value ?? '')] }));
}
class EditorBoundary extends Component {
    state = { failed: false };
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch(error) {
        console.error('[flow] el editor de la nota no se ha podido cargar', error);
    }
    render() {
        return this.state.failed ? this.props.fallback : this.props.children;
    }
}
export function NoteField(props) {
    return (_jsx(EditorBoundary, { fallback: _jsx(PlainNote, { ...props }), children: _jsx(Suspense, { fallback: _jsx(PlainNote, { ...props, disabled: true }), children: _jsx(NoteEditor, { ...props }) }) }));
}
//# sourceMappingURL=NoteField.js.map